import { type SchedulePreferencesPayload } from '@/features/accounts/api';
import type { CatalogFacility } from '@catalog';
import { DateInterest, Facility, Schedule } from '@/features/accounts/types';

interface SummaryView {
  interest: DateInterest;
  facilities: Facility[] | null;
}

export function summaryView(
  schedule: Schedule,
  catalog: CatalogFacility[],
  preferences?: SchedulePreferencesPayload
): SummaryView {
  if (!preferences) {
    return { interest: schedule.date_interest, facilities: schedule.preferred_facilities };
  }

  return {
    interest: {
      configured: true,
      accept: preferences.accept,
      exclude: preferences.exclude,
      min_days_from_now: preferences.min_days_from_now ?? 0,
      max_gap_between_asc_and_consular: preferences.max_gap_between_asc_and_consular,
      min_same_day_gap: preferences.min_same_day_gap,
      allow_cancellation: preferences.allow_cancellation,
      accept_worse_date: preferences.accept_worse_date,
    },
    facilities: named(preferences.preferred_facilities, catalog),
  };
}

function named(codes: string[], catalog: CatalogFacility[]): Facility[] {
  const byCode = new Map(catalog.map((facility) => [facility.code, facility]));

  return codes.map((code) => byCode.get(code) ?? { code, name: code });
}
